import { isDefined } from "@clipboard-health/util-ts";
import { Button, Stack } from "@mui/material";
import { type AdminMessage } from "@sendbird/chat/message";
import { useHistory } from "react-router-dom";

import { PRIMARY_BUTTON_SX } from "../redesign/components/Button.styles";
import { getLocation } from "../redesign/utils/routes";
import { ChatWidgetCard } from "./ChatWidgetCard";
import { parseNumberOfInvitesFromShiftInviteMessage } from "./utils";

interface GroupShiftInviteRequestMessageProps {
  message: AdminMessage;
}

export function GroupShiftInviteRequestMessage(props: GroupShiftInviteRequestMessageProps) {
  const { message } = props;
  const history = useHistory();

  const numberOfInvites = parseNumberOfInvitesFromShiftInviteMessage(message);

  const title = isDefined(numberOfInvites)
    ? `You sent ${numberOfInvites} shift invites`
    : "You sent multiple shift invites";

  const handleViewCalendar = () => {
    history.push(getLocation("facilityDashboard"));
  };

  return (
    <Stack alignItems="flex-end" className="sendbird-admin-message">
      <ChatWidgetCard
        title={title}
        actions={
          <Button
            size="small"
            variant="outlined"
            sx={{ ...PRIMARY_BUTTON_SX, flex: 1 }}
            onClick={handleViewCalendar}
          >
            View calendar
          </Button>
        }
      />
    </Stack>
  );
}
